// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__3P27C","content":"LoadingAlert_content__3IfMk"};